<template>
	<div class="user_content_blcok">
		<div class="user_content_blcok_title" style="position: relative;">
			个人订单
			<div class="order_search" v-if="false">
				<el-input placeholder="请输入订单号" v-model="order_no">
					<el-button @click="get_user_order()" slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div class="order_type">
				<ul>
					<li @click="order_type='';order_no='';get_user_order()" :class="order_type==''?'red':''">全部
						({{order_num.all}})</li>
					<li @click="order_type='1';order_no='';get_user_order()" :class="order_type=='1'?'red':''">待支付
						({{order_num.no_pay}})</li>
					<li @click="order_type='2';order_no='';get_user_order()" :class="order_type=='2'?'red':''">
						待发货 ({{order_num.wait_send}})</li>
					<li @click="order_type='7';order_no='';get_user_order()" :class="order_type=='7'?'red':''">待收货
						({{order_num.wait_rec}})</li>
					<li @click="order_type='REFUND';order_no='';get_user_order()"
						:class="order_type=='REFUND'?'red':''">售后处理 ({{order_num.refund}})</li>
				</ul>
			</div>
			<div class="clear"></div>
		</div>
		<div class="user_content_blcok_line"></div>

		<div class="user_index_order_list" v-if="order_list.length>0">
			<div class="user_index_store_list" v-for="(v,k) in order_list" :key="k">
				<div class="user_index_store_title">订单号：{{v.ordCode}}
					<div class="order_time">{{orderTypeDesc(v.ordTag)}}</div>
					<div class="order_time">{{v.ordDt}}</div>
				</div>
				<ul>
					<li v-for="(vo,key) in v.orderItemVOs" :key="key">
						<router-link :to="'/goods/info/'+vo.shareGoodsId">
							<div class="user_order_goods_thumb"><img width="40px" height="40px" :src="vo.imgurl" alt="">
							</div>
							<div class="user_order_goods_title">{{vo.name}}</div>
							<div class="user_order_goods_price">￥{{vo.prodsPrice}}</div>
							<div class="user_order_goods_num">{{vo.sn_code||' - '}}</div>
							<div class="user_order_goods_num">x{{vo.prodsNum}}</div>
						</router-link>
						<div class="clear"></div>

					</li>
				</ul>
				<!-- 处理订单 -->
				<div class="handle_btn">
					<el-button type="danger" v-if="v.ordTag=='1'" @click="pay(k)">前往支付</el-button>
					<el-button v-if="v.ordTag=='1'" @click="close_order(v.ordersId)">取消订单</el-button>
					<el-button type="danger" v-if="v.ordTag=='7'" @click="change_order_status(v.ordersId)">确认收货</el-button>
					<el-button v-if="v.ordTag=='7'" @click="delivery_show(v)">查看物流</el-button>
					<el-button type="warning" v-if="!v.processingState!='0' && ['2','7'].indexOf(v.ordTag)>=0"
						@click="open_after_sale(v)">申请售后</el-button>
					<el-button v-if="v.processingState==3">售后结束</el-button>
					<el-button type="warning" v-if="v.processingState" @click="open_after_sale(v)">查看售后</el-button>
				</div>
			</div>
		</div>
		<!-- 没有订单则 -->
		<div class="empty_order" v-else>
			<dl v-if="order_type=='REFUND'" style="padding-bottom: 5em; text-align: center;">
				如有疑问请联系：{{conactTel}}
			</dl>
			<dl>
				<dt><img src="/pc/not-common-icon.png" alt=""></dt>
				<dd>主人，您近期还没有购买任何商品哟~</dd>
				<dd class="btn">
					<router-link to="/">前往商城</router-link>
				</dd>
			</dl>
		</div>

		<div class="home_fy_block" v-show="order_list.length>0">
			<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total"
				:total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
		</div>

		<!-- 物流显示 -->
		<el-dialog title="物流列表" :visible.sync="deliveryShow">
			<!-- 快递信息 -->
			<div class="freight_info">
				<div>
					物流单号：{{deliveryInfo.transCode}}
				</div>
				<div>
					物流公司：{{deliveryInfo.transCorpName}}
				</div>
				<el-timeline
					v-if="delivery_list != undefined && delivery_list != null && delivery_list.result.list.length>0">
					<el-timeline-item size='large' color="#0bbd87" :timestamp="delivery_list.result.list[0].time">
						{{delivery_list.result.list[0].status}}
					</el-timeline-item>
					<el-timeline-item v-for="(vo,kess) in delivery_list.result.list" :key="kess" v-show="kess>=1"
						:timestamp="vo.time">{{vo.status}}</el-timeline-item>
				</el-timeline>
				<div class="no_freight" v-else>
					没有任何快递信息
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deliveryShow = false">关 闭</el-button>
			</span>
		</el-dialog>

		<!-- 售后处理 -->
		<el-dialog title="售后处理" :visible.sync="afterSale">
			<div class="after_sale">
				<el-form ref="after_sale" label-width="120px">
					<el-form-item label="订单号">
						{{afterSaleInfo.ordCode}}
					</el-form-item>
					<el-form-item label="退款/换货">
						<div class="red_radio" v-if="afterSaleInfo.processingState == null">
							<el-radio-group v-model="afterParams.refund_status">
								<el-radio :label="1">退款</el-radio>
								<el-radio :label="2">换货</el-radio>
							</el-radio-group>
						</div>
						<div v-else>{{afterSaleInfo.refund_status==1?'退款':'退货'}}</div>
					</el-form-item>
					<el-form-item label="退款/退货原因">
						<el-input v-if="afterSaleInfo.processingState == null" type="text" placeholder="请输入原因"
							v-model="afterParams.refund_info" maxlength="100" show-word-limit></el-input>
						<div v-else>{{afterSaleInfo.refund_info}}</div>
					</el-form-item>
					<el-form-item label="申请时间" v-if="afterSaleInfo.applyTime">
						{{afterSaleInfo.applyTime}}
					</el-form-item>
					<el-form-item label="输入快递单号" v-if="afterSaleInfo.refund_step == 1">
						<el-input type="text" placeholder="请输入快递单号" v-model="afterParams.refund_delivery_no"
							maxlength="100" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="商家发货单号" v-if="afterSaleInfo.ordTag == 7">
						{{afterSaleInfo.ordCode+'（商家已经发货，收到商品后请确定收货）'}}
					</el-form-item>
					<el-form-item label="商家发货单号" v-if="afterSaleInfo.processingState == 3">
						售后已经处理结束！
					</el-form-item>
				</el-form>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="afterSale = false">关 闭</el-button>
				<el-button type="danger" v-if="afterSaleInfo.processingState==null" @click="refund()">申 请</el-button>
				<el-button type="danger" v-if="afterSaleInfo.refund_step==1" @click="refund_no()">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getOrderList,
		cancelOrder,
		addAfterSale,
		getAfterSale,
		confirmReceive
	} from '../../../api/api.js'
	import { config } from '@/api/config/default.js'
	export default {
		components: {},
		props: {},
		data() {
			return {
				conactTel: config.conactTel,
				order_list: [],
				order_num: {},
				total_data: 0, // 总条数
				page_size: 20,
				current_page: 1,
				order_no: '',
				order_type: '',
				deliveryShow: false,
				deliveryInfo:{},
				delivery_list: undefined,
				afterSale: false,
				afterSaleInfo: {
					id: 0,
				},
				afterParams: {
					refund_status: 1,
				},
			};
		},
		watch: {},
		computed: {},
		methods: {
			orderTypeDesc(ordTag) {
				let desc = ""
				switch (ordTag) {
					case '':
						desc = "全部"
						break;
					case '1':
						desc = "待支付"
						break;
					case '2':
						desc = "待发货"
						break;
					case '7':
						desc = "待收货"
						break;
					case '9':
						desc = "已取消"
						break;
					case '10':
						desc = "已完成"
						break;
					case 'REFUND':
						desc = "售后处理"
						break;
				}
				return desc;
			},
			get_user_order: function() {
				// console.log(this.order_type);
				getOrderList({
					page: this.current_page,
					per_page: this.page_size,
					ordTag: this.order_type == 'REFUND' ? '' :this.order_type,
					caseFal: this.order_type == 'REFUND' ? '1' : ''
				}).then(res => {
					this.order_list = res.data.records;
					this.total_data = parseInt(res.data.total);
					this.page_size = res.data.size
					this.current_page = res.data.current;
					switch (this.order_type) {
						case '':
							this.order_num.all = this.total_data;
							break;
						case '1':
							this.order_num.no_pay = this.total_data;
							break;
						case '2':
							this.order_num.wait_send = this.total_data;
							break;
						case '7':
							this.order_num.wait_rec = this.total_data;
							break;
						case 'REFUND':
							this.order_num.refund = this.total_data;
							break;
					}
				});
			},
			// 分页改变
			current_change: function(e) {
				this.current_page = e;
				this.search_goods();
			},
			pay: function(index) {
				let order_info = this.order_list[index];
				return this.$router.push({
					name: 'home_chose_pay',
					params: {
						ordersId: order_info.ordersId
					}
				})
			},
			// 取消订单
			close_order: function(ordersId) {
				this.$confirm("确认取消订单").then(res => {
					cancelOrder(ordersId).then(res => {
						if (res.code == 0) {
							this.get_user_order();
							return this.$message.success('取消订单成功');
						} else {
							return this.$message.error(res.msg);
						}
					});
				})
			},
			delivery_show: function(order) {
				this.deliveryInfo.transCorpName = order.transCorpName
				this.deliveryInfo.transCode = order.transCode
				this.deliveryShow = true;
			},
			// 修改订单状态
			change_order_status: function(id) {
				this.$confirm("确认收货？").then(res=>{
					confirmReceive(id).then(() => {
						this.get_user_order();
						this.$message.success('确认收货成功');
					});
				})
				
			},
			// 打开售后处理
			open_after_sale: function(v) {
				this.afterSale = true;
				this.afterSaleInfo = v;
				getAfterSale(this.afterSaleInfo.afterSalesId).then(res=>{
					if(res.code == 0){
						this.afterSaleInfo.refund_info = res.data.problem
						this.afterSaleInfo.applyTime = res.data.applyTime
					}
				})
			},
			refund: function() {
				let data = {
					orderId: this.afterSaleInfo.ordersId,
					memberId: this.afterSaleInfo.memberId,
					problem: this.afterParams.refund_info,
					afterSalesType: this.afterParams.refund_status == "1" ? 1 : 2,
					returnProductSum: this.afterSaleInfo.itemsNum,
					refundMethod: "1",
					refundAmount: this.afterSaleInfo.totalPrice,
					productIds: this.afterSaleInfo.orderItemVOs.map(m => m.productId)
				}
				addAfterSale(data).then((res) => {
					if (res.code == 0) {
						this.$message.success('申请成功');
						this.afterSale = false;
						this.get_user_order();
					} else {
						this.$message.error('申请失败');
					}

				});
			},
			refund_no: function() {
				this.afterParams.id = this.afterSaleInfo.id;
				this.$post(this.$api.homeOrderRefundDelivery, this.afterParams).then(() => {
					this.$message.success('提交成功');
					this.afterSale = false;
					this.get_user_order();
				});
			}
		},
		created() {
			if (!this.$isEmpty(this.$route.params.order_type)) {
				this.order_type = this.$route.params.order_type;
			}
			this.get_user_order();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.no_freight {
		line-height: 60px;
		text-align: center;
		font-size: 14px;
		color: #999;
	}

	.handle_btn {
		text-align: right;
		margin: 20px 0;
	}

	.user_index_order_list {
		margin-bottom: 50px;
	}

	.order_time {
		margin-left: 20px;
		color: #666;
		float: right;
		font-size: 12px;
	}

	.user_index_store_list {
		ul {
			border: 1px solid #efefef;

		}

		ul li {
			border-bottom: 1px solid #efefef;
			padding: 20px 15px;
		}

		ul li:last-child {
			border-bottom: none;
		}
	}

	.user_order_goods_thumb {
		float: left;
		margin-right: 15px;
		display: block;
		width: 40px;

	}

	.user_order_goods_title {
		font-size: 12px;
		color: #666;
		width: 280px;
		float: left;
	}

	.user_order_goods_num {
		font-size: 12px;
		color: #666;
		float: left;
		display: block;
		line-height: 40px;
		width: 200px;
		text-align: center;
	}

	.user_order_goods_price {
		font-size: 12px;
		line-height: 40px;
		color: #ca151e;
		width: 90px;
		float: left;
	}

	.order_search {
		float: right;
		margin-left: 20px;
		position: absolute;
		right: 10px;
		top: -5px;
		width: 180px;
	}

	.user_index_store_title {
		background: #f6f6f6;
		line-height: 40px;
		color: #666;
		padding: 0 15px;
		margin: 20px 0;

		a:hover {
			color: #ca151e;
		}
	}

	.order_type {
		float: right;
		font-size: 14px;
		margin-top: 2px;

		ul {
			margin-right: 280px;

		}

		ul li {
			color: #999;
			float: left;
			margin-right: 20px;
		}

		ul li.red {
			color: #ca151e;
		}

		ul li:hover {
			color: #ca151e;
		}
	}
</style>
